module.exports = "<span class=\"sort-container\" (click)=\"onClickHeader()\">\n  <ng-content></ng-content>\n  <span *ngIf=\"sortType==='desc'\"><i class=\"fa fa-arrow-up\"></i></span>\n  <span *ngIf=\"sortType==='asc'\"><i class=\"fa fa-arrow-down\"></i></span>\n  <span *ngIf=\"!sortType\"></span>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/sort-header/sort-header.component.html
// module id = ./src/app/common/sort-header/sort-header.component.html
// module chunks = main